export default __webpack_public_path__ + "static/media/Kuthcheman Tower Shield.5b6f9329.jpg";